import React from 'react';
import CareersPage from './Page.tsx';
import PageFade from '@/common/components/PageFade.tsx';

const CareersRoute: React.FC = () => {
  return (
    <PageFade>
      <CareersPage />
    </PageFade>
  );
};

export default CareersRoute;
